import { Brain, ChartLine, Layers, Upload } from 'lucide-react';

import { IconButtonWithBadge } from './IconButtonWithBadge';
import type { CollapsedSidebarProps } from './types';

export function CollapsedSidebar({
    appCount,
    artifactCount,
    podcastCount,
    uploadCount,
    isFileUploadEnabled,
    activePanel,
    onOpenPanel
}: CollapsedSidebarProps) {
    return (
        <div className="hidden md:flex flex-col items-center bg-background px-3 py-4 border-border border-l h-full">
            <div className="relative flex flex-col justify-center items-center gap-3">
                <IconButtonWithBadge
                    icon={Brain}
                    title="Agents"
                    active={activePanel === 'agents'}
                    onClick={() => onOpenPanel('agents')}
                />

                <IconButtonWithBadge
                    icon={ChartLine}
                    count={appCount}
                    title="View Charts"
                    active={activePanel === 'apps'}
                    onClick={() => onOpenPanel('apps')}
                />

                <IconButtonWithBadge
                    icon={Layers}
                    count={artifactCount}
                    title="Artifacts"
                    active={activePanel === 'artifacts'}
                    onClick={() => onOpenPanel('artifacts')}
                />

                {isFileUploadEnabled && (
                    <IconButtonWithBadge
                        icon={Upload}
                        count={uploadCount}
                        title="Uploaded/Embedded Files"
                        active={activePanel === 'uploads'}
                        onClick={() => onOpenPanel('uploads')}
                    />
                )}
            </div>
        </div>
    );
}
